<template>
  <div class="footer text-center">Copyright © 2018 TRADERS SECURITIES CO., LTD. All rights reserved.</div>
</template>

<script>
    /**
     * @author HungNS
     */
    export default {

}
</script>

<style>

</style>